<script setup lang="ts">
import { computed, ref } from "vue";

const name = ref("student_name");

const pythonKeywords = new Set([
  "False", "None", "True", "and", "as", "assert", "async", "await", "break", "class", "continue",
  "def", "del", "elif", "else", "except", "finally", "for", "from", "global", "if", "import", "in",
  "is", "lambda", "nonlocal", "not", "or", "pass", "raise", "return", "try", "while", "with", "yield",
]);

const result = computed(() => {
  const value = name.value.trim();

  if (!value) {
    return {
      valid: false,
      label: "Name likhein",
      detail: "Pehle koi variable name type karein.",
    };
  }

  if (!/^[A-Za-z_]/.test(value)) {
    return {
      valid: false,
      label: "Invalid variable name",
      detail: "Variable name letter ya underscore se start hota hai.",
    };
  }

  if (!/^[A-Za-z0-9_]+$/.test(value)) {
    return {
      valid: false,
      label: "Invalid variable name",
      detail: "Spaces aur special characters allowed nahi hotay.",
    };
  }

  if (pythonKeywords.has(value)) {
    return {
      valid: false,
      label: "Invalid variable name",
      detail: "Python keyword ko variable name ke taur par use nahi kar sakte.",
    };
  }

  return {
    valid: true,
    label: "Valid variable name",
    detail: "Yeh name Python variable ke liye sahi hai.",
  };
});

function applySample(sample: string) {
  name.value = sample;
}
</script>

<template>
  <article class="rounded-3xl border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
    <div class="space-y-1">
      <h2 class="text-lg font-semibold text-slate-900 dark:text-white">Is name ko check karo</h2>
      <p class="text-sm text-slate-600 dark:text-slate-300">Yahan naam likho. Hum foran batayenge ke yeh sahi variable name hai ya nahi.</p>
    </div>

    <label class="mt-4 block space-y-2">
      <span class="text-sm font-medium text-slate-700 dark:text-slate-200">Naam likho</span>
      <input
        v-model="name"
        type="text"
        class="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm outline-none focus:border-sky-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
      >
    </label>

    <div class="mt-4 flex flex-wrap gap-2">
      <button
        v-for="sample in ['student_name', '1name', 'totalMarks', 'my name', 'for']"
        :key="sample"
        type="button"
        class="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-medium text-slate-700 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        @click="applySample(sample)"
      >
        {{ sample }}
      </button>
    </div>

    <div
      class="mt-4 rounded-2xl p-4 ring-1"
      :class="result.valid
        ? 'bg-emerald-50 text-emerald-900 ring-emerald-200 dark:bg-emerald-950/20 dark:text-emerald-200 dark:ring-emerald-900/50'
        : 'bg-rose-50 text-rose-900 ring-rose-200 dark:bg-rose-950/20 dark:text-rose-200 dark:ring-rose-900/50'"
    >
      <p class="text-xs font-semibold uppercase tracking-[0.18em]">Answer</p>
      <p class="mt-1 text-lg font-bold">{{ result.label }}</p>
      <p class="mt-1 text-sm">{{ result.detail }}</p>
    </div>
  </article>
</template>
